import * as React from 'react';
import JMuxerVideo from 'components/players/JMuxerVideo';
import H264LivePlayerWW from 'components/players/H264LivePlayerWW';
// import { isSupported } from 'utils/mediasource-helper';
import { getAbsoluteHost, settingsConfig } from 'utils/commonFunc';

export default function RtspPlayer(props) {
    const def = {
        poster:getAbsoluteHost('/images/VideoLoader.gif'),
        fps:settingsConfig().cctvFps,
        ...props
    }

    return settingsConfig().mseSupport === true
    ? <JMuxerVideo {...def} />
    : <H264LivePlayerWW {...def} />
}